var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vote-item-tag overflow-hidden bg-highlight text-interaction-dark text-chplus-s rounded-lg",class:{
    'items-center flex flex-col w-24 h-20 p-2': !_vm.inline,
    'px-2': _vm.inline
  }},[_c('vote-topic-icon',{class:{ 'mr-1': _vm.inline, 'w-full flex-grow': !_vm.inline },attrs:{"topic":_vm.topic}}),_c('span',{staticClass:"truncate w-full"},[_vm._v(_vm._s(_vm.topic.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }